import { X } from "react-feather";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Btn, H6 } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Href, Instock, CancelledOrder, Price,Cancelled } from "../../../../Constant";
import { STAR_DATAS } from "../../../../Data/Ecommerce";
import { useAppDispatch, useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import { setCancelledOrders } from "../../../../Redux-Toolkit/Reducers/RecentOrderSlice";
import { dynamicImage } from "../../../../Service/DynamicImage";

const CancelledOrders = () => {
  const { cancelledOrder } = useAppSelector((state) => state.recentOrder);
  const dispatch = useAppDispatch();
  const delethandler = (id: number) => dispatch(setCancelledOrders(id));

  return (
    <Card>
    <CommonCardHeader title={CancelledOrder} />
    <CardBody>
      <Row className="g-sm-4 g-3">
        {cancelledOrder.map((item, index) => (
          <Col xl="4" md="6" key={index}>
            <div className="prooduct-details-box">
              <div className="d-flex">
                <img className="align-self-center img-fluid img-60" src={dynamicImage(`ecommerce/${item.image}`)} alt={Href} />
                <div className="flex-grow-1 ms-3">
                  <div className="product-name"><H6><a href={Href}>{item.title}</a></H6></div>
                  {STAR_DATAS}
                  <div className="price d-flex"><div className="text-muted">{Price}</div>: {item.price}$</div>
                  <div className="avaiabilty"><div className="text-success">{Instock}</div></div>
                  <Btn as="a" color="danger" size="xs" href={Href}>{Cancelled}</Btn>
                  <X className="close" onClick={() => delethandler(item.id)} />
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </CardBody>
  </Card>
  )
};

export default CancelledOrders;
